import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import Breadcrumbs, {CrumbLink} from 'nav/Breadcrumbs';
import * as StorableActions from 'samples/StorableActions';

import {InaccessibleInfoGraphQL} from '../../../graphql-fragments/auth/__generated/InaccessibleInfoGraphQL';

interface StorableAncestor {
  __typename?: string;
  id: string;
  name: string;
  storableSchema: {registry: {id: string}};
}

export default function StorableBreadcrumbs(props: {
  storable: {
    __typename?: string;
    id: string;
    name: string;
    storableSchema: {registry: {id: string}};
    ancestry: Array<StorableAncestor | InaccessibleInfoGraphQL>;
  };
}): JSX.Element | null {
  const ancestryAndSelf = [props.storable, ...props.storable.ancestry];
  ancestryAndSelf.reverse();

  const crumbs = ancestryAndSelf.map((storableOrInaccessible) => {
    if (isInaccessible(storableOrInaccessible)) {
      return <CrumbLink key={`crumb-${storableOrInaccessible.invalidId}`} text="(No access)" />;
    } else {
      const storable: {id: string; name: string; storableSchema: {registryId: string}} = {
        ...storableOrInaccessible,
        storableSchema: {
          registryId: storableOrInaccessible.storableSchema.registry.id,
        },
      };
      return (
        <CrumbLink
          key={`crumb-${storableOrInaccessible.id}`}
          text={storableOrInaccessible.name}
          onClick={() => {
            StorableActions.open(storable);
          }}
        />
      );
    }
  });

  return <Breadcrumbs crumbs={crumbs} />;
}
